var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertWarn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "alert-warn_svg__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.850980 0 0 0 0 0.678431 0 0 0 0 0.000000 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#alert-warn_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#165C7D",
  d: "M9.89 12.067a.703.703 0 0 0 .702-.701v-4.91a.702.702 0 0 0-1.402 0v4.91c0 .386.315.701.7.701m0 1.455a1.014 1.014 0 1 1 0 2.026 1.014 1.014 0 0 1 0-2.025"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#165C7D",
  d: "M17.472 17.085c-.06.102-.196.277-.424.277l-14.097-.02c-.228 0-.365-.173-.428-.274a.83.83 0 0 1-.031-.8l6.89-13.553c.102-.2.266-.326.45-.326h.002c.183 0 .348.119.453.319l7.203 13.567a.84.84 0 0 1-.018.81m1.255-1.469-7.206-13.56C11.171 1.391 10.54 1 9.831 1h-.018c-.711.007-1.343.41-1.686 1.084L1.24 15.63a2.24 2.24 0 0 0 .084 2.167c.361.589.967.947 1.623.947l14.097.021h.004c.663 0 1.27-.362 1.627-.958a2.25 2.25 0 0 0 .052-2.191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.472 17.085c-.06.102-.196.277-.424.277l-14.097-.02c-.228 0-.365-.173-.428-.274a.83.83 0 0 1-.031-.8l6.89-13.553c.102-.2.266-.326.45-.326h.002c.183 0 .348.119.453.319l7.203 13.567a.84.84 0 0 1-.018.81m1.255-1.469-7.206-13.56C11.171 1.391 10.54 1 9.831 1h-.018c-.711.007-1.343.41-1.686 1.084L1.24 15.63a2.24 2.24 0 0 0 .084 2.167c.361.589.967.947 1.623.947l14.097.021h.004c.663 0 1.27-.362 1.627-.958a2.25 2.25 0 0 0 .052-2.191"
})))));
export { SvgAlertWarn as ReactComponent };
export default __webpack_public_path__ + "img/alert-warn.670099a9869ac583ec5e68b02fdd3634.svg";